import React from 'react';
import Pawn from '../Pawn/Pawn'; // On importe le composant Pion
import './Board.scss';

// On réceptionne les infos envoyées par Game.js
const Board = ({ players = [], activePlayerIndex = 0 }) => {
    
    const boardCells = [
        { id: 1, type: 'maison', colorClass: 'bg-violet', icon: '🏠', label: 'Violet', points: 50 },
        { id: 2, type: 'quizz1', icon: '❓', label: 'Quiz 1', points: 30 },
        { id: 3, type: 'defi', icon: '⚔️', label: 'Défi', points: 100 },
        { id: 4, type: 'quizz1', icon: '❓', label: 'Quiz 1', points: 30 },
        { id: 5, type: 'maison', colorClass: 'bg-bleu', icon: '🏠', label: 'Bleu', points: 50 },
        { id: 6, type: 'quizz1', icon: '❓', label: 'Quiz 1', points: 30 },
        { id: 7, type: 'quizz2', icon: '❓', label: 'Quiz 2', points: 50 },
        { id: 8, type: 'vide', points: 0 },
        { id: 9, type: 'quizz2', icon: '❓', label: 'Quiz 2', points: 50 },
        { id: 10, type: 'quizz1', icon: '❓', label: 'Quiz 1', points: 30 },
        { id: 11, type: 'defi', icon: '⚔️', label: 'Défi', points: 100 },
        { id: 12, type: 'vide', points: 0 },
        { id: 13, type: 'bonus', icon: '🏆', label: 'Bonus', points: 100 },
        { id: 14, type: 'vide', points: 0 },
        { id: 15, type: 'defi', icon: '⚔️', label: 'Défi', points: 100 },
        { id: 16, type: 'quizz1', icon: '❓', label: 'Quiz 1', points: 30 },
        { id: 17, type: 'quizz2', icon: '❓', label: 'Quiz 2', points: 50 },
        { id: 18, type: 'vide', points: 0 },
        { id: 19, type: 'quizz2', icon: '❓', label: 'Quiz 2', points: 50 },
        { id: 20, type: 'quizz1', icon: '❓', label: 'Quiz 1', points: 30 },
        { id: 21, type: 'maison', colorClass: 'bg-jaune', icon: '🏠', label: 'Jaune', points: 50 },
        { id: 22, type: 'quizz1', icon: '❓', label: 'Quiz 1', points: 30 },
        { id: 23, type: 'defi', icon: '⚔️', label: 'Défi', points: 100 },
        { id: 24, type: 'quizz1', icon: '❓', label: 'Quiz 1', points: 30 },
        { id: 25, type: 'maison', colorClass: 'bg-vert', icon: '🏠', label: 'Vert', points: 50 },
    ];

    return (
        <div className="board-container">
            <div className="board-grid">
                {boardCells.map((cell) => {
                    // On cherche tous les joueurs dont la position correspond à l'ID de cette case
                    const playersOnCell = players.filter(player => player.position === cell.id);

                    return (
                        <div key={cell.id} className={`board-cell ${cell.type} ${cell.colorClass || ''}`}>
                            {cell.icon && <span className="cell-icon">{cell.icon}</span>}
                            {cell.label && <span className="cell-label">{cell.label}</span>}
                            
                            {/* S'il y a des joueurs sur cette case, on les affiche par-dessus l'icône */}
                            {playersOnCell.length > 0 && (
                                <div className="pawns-container">
                                    {playersOnCell.map((player) => {
                                        // On vérifie si c'est le tour de ce joueur pour activer son ombre fluo
                                        const isMyTurn = players.findIndex(p => p.id === player.id) === activePlayerIndex;
                                        
                                        return (
                                            <Pawn 
                                                key={player.id} 
                                                color={player.color} 
                                                isActive={isMyTurn} 
                                            />
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Board;